import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { Amount } from '@lx/shared/data-access/types';
import { DurationUnitsLabelPipe } from '@lx/shared/ui/pipes';
import { Observable, filter, map } from 'rxjs';
import { StudyPeriodPipe } from '@lx/quote-tool/lite/shared/ui/pipes';
import { ChristmasClosureDisclaimerService } from '../../services';
import { QuoteState, QuoteStore, QuoteToolLiteState, QuoteToolLiteStore } from '../../store';
import { QuoteBreakdown } from '../../types';
import { QuoteBreakdownSectionComponent } from './quote-breakdown-section/quote-breakdown-section.component';
import { Flows, Flow } from '@lx/quote-tool/lite/shared/types';

@Component({
  standalone: true,
  selector: 'lx-quote-breakdown',
  templateUrl: './quote-breakdown.component.html',
  styleUrls: ['./quote-breakdown.component.scss'],
  imports: [AsyncPipe, NgIf, StudyPeriodPipe, QuoteBreakdownSectionComponent, NgForOf, DurationUnitsLabelPipe],
})
export class QuoteBreakdownComponent implements OnInit {
  currency$: Observable<string> | undefined;
  quoteBreakdown$: Observable<QuoteBreakdown> | undefined;
  courseDetails$: Observable<Partial<QuoteToolLiteState>> | undefined;
  packageDetails$: Observable<Partial<QuoteState>> | undefined;
  depositAmounts$: Observable<Amount[] | undefined>;
  activeFlow$: Observable<Flow> | undefined;

  disclaimer$: Observable<string | undefined>;

  protected readonly Flows = Flows;

  private readonly quoteStore = inject(QuoteStore);
  private readonly quoteToolLiteStore = inject(QuoteToolLiteStore);
  private readonly christmasClosureDisclaimerService = inject(ChristmasClosureDisclaimerService);

  ngOnInit(): void {
    this.currency$ = this.quoteToolLiteStore.selectedCurrency$;
    this.quoteBreakdown$ = this.quoteStore.quoteBreakdown$;
    this.courseDetails$ = this.quoteToolLiteStore.courseDetails$;
    this.packageDetails$ = this.quoteStore.packageDetails$;
    this.depositAmounts$ = this.quoteStore.payableData$.pipe(
      filter(Boolean),
      map(({ amounts }) => amounts),
    );
    this.activeFlow$ = this.quoteToolLiteStore.activeFlow$;
    this.disclaimer$ = this.christmasClosureDisclaimerService.getDisclaimerForSelectedDates();
  }
}
